import React from 'react';
import Overlay from '../../../../components/Overlay/overlay';
import { Button, Col, Container, Form, FormGroup, Input, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear, faRefresh, faSpinner, faTrash, faWarning } from '@fortawesome/free-solid-svg-icons';
import { connect, useSelector } from 'react-redux';
import axios from 'axios';
import downloadCSV from '../../../../utilities/downloadCSV';
const { REACT_APP_API_URL } = process.env;

const OverlayCombinedReport = ({ isOpen, reset, onToggle, config, updateConfig, surveyNameById, orgName }) => {
  const initialState = {
    generateInProgress: false,
    reportBlob: null,
    reportFilename: null,
  }
  const [state, setState] = React.useState(initialState)
  const API_TOKEN = useSelector(state => state.auth.idToken);
  const onToggleWithUpdate = () => {
    handleLabelChange();
    onToggle();
  }
  const handleLabelChange = () => {
    const formData = new FormData(document.getElementById('combinedReportForm'));
    const newConfig = [...config];
    for (let index = 0; index < config.length; index++) {
      newConfig[index].label = formData.get(`period-${index}-label`);
    }
    updateConfig(newConfig);
  }
  const removePeriod = (i) => {
    const newConfig = [...config]; // copy array to avoid mutating props
    newConfig.splice(i, 1); // remove the element
    updateConfig(newConfig);
  }
  const resetAll = () => {
    setState(initialState)
    reset();
  }

  const generateReport = async () => {
    const payload = {
      "options": {
        data: false
      },
      "itemId": config
    };
    const formData = new FormData(document.getElementById('combinedReportForm'));
    for (let index = 0; index < config.length; index++) {
      payload.itemId[index].label = formData.get(`period-${index}-label`);
    }
    const mockrun = formData.get("mockrun");
    if (mockrun) {
      console.log("mockrun with payload:");
      console.log(JSON.stringify(payload))
      return { mock: true };
    } else {
      const response = await axios({
        url: `${REACT_APP_API_URL}/reports/v2/generateSchoolXlsx`,
        method: 'POST',
        headers: { Authorization: API_TOKEN },
        data: payload,
        responseType: 'blob'
      })
      return {
        csvBlob: response.data,
        // filename: response.headers["X-TM-Filename"] 
        filename: `Report Data ${orgName} (${payload.itemId[0].label}).csv`,
        mock: false,
      }
    }
  }
  const formSubmit = async () => {
    setState((prevState) => ({
      ...prevState,
      generateInProgress: true,
    }));
    const { csvBlob, filename, mock } = await generateReport();
    if (!mock)
      setState((prevState) => ({
        ...prevState,
        generateInProgress: false,
        reportBlob: csvBlob,
        reportFilename: filename,
      }));
  }
  const downloadReport = () => {
    // window.open(state.reportUrl, "_blank")
    downloadCSV({ csvBlob: state.reportBlob, filename: state.reportFilename })
    resetAll(); // should we do that?
  }

  return (
    <div>
      <Overlay
        isOpen={isOpen}
        onToggle={onToggleWithUpdate}
        title={<><FontAwesomeIcon icon={faGear} /> Combined Report Configuration</>}
        variant="small"
      >
        <Container>
          <p>
            A combined report aggregates data from multiple assessments.
          </p>
          <Form id="combinedReportForm">
            {config.map((c, idx) => <FormGroup key={`period-${idx}`} className="border rounded p-3">
              <FontAwesomeIcon onClick={() => removePeriod(idx)} title="Remove this period" icon={faTrash} className='float-right' />
              <h2>Period {idx + 1}</h2>
              <FormGroup row className="d-flex align-items-center">
                <Label sm={3} for={`period-${idx}-label`}>Label</Label>
                <Col sm={9}>
                  <Input name={`period-${idx}-label`} defaultValue={c.label} type='text' />
                </Col>
              </FormGroup>
              <FormGroup row >
                <Col sm={3}>Assessments</Col>
                <Col sm={9}>
                  <ul>
                    {c.surveyIds.map(s => <li key={`survey-${s}`}>{surveyNameById[s]}</li>)}
                  </ul>
                </Col>
              </FormGroup>
            </FormGroup>)}
            {config.length > 4 ? (
              <p>You have reached the maximum number of periods allowed.</p>
            ) : (<p>To add a reference period to your report please <Button color='primary' outline onClick={onToggleWithUpdate} >Select Reference</Button></p>
            )}
            {(state.reportBlob === null) ?
              <>
                {config.length < 3 && <p className='text-danger mb-1'><FontAwesomeIcon className='me-2' icon={faWarning} />At least 3 periods are required</p>}
                <Button disabled={!state.generateInProgress && config.length < 3} onClick={formSubmit} color='primary'>{state.generateInProgress && <FontAwesomeIcon className="fa-spin me-3" icon={faSpinner} />}{state.generateInProgress ? 'Please wait' : 'Generate Report Data'}</Button>
              </>
              : <Button color="success" onClick={downloadReport} >Download Report Data</Button>}
            <Button color='secondary' className="ms-3" onClick={resetAll}><FontAwesomeIcon icon={faRefresh} /> Reset</Button>
            <FormGroup row className='d-flex align-items-center'>
              <Label sm={3} for="mockrun">Mock run</Label>
              <Col sm={9}>
                <Input name="mockrun" type='checkbox' />
              </Col>
            </FormGroup>
          </Form>
        </Container>
      </Overlay>
    </div >
  );
}
const mapStateToProps = state => {
  return {
    surveyNameById: Object.fromEntries(state.surveyCrud.surveys.map(s => [s.surveyId, `${s.surveyName} (${s.semester} ${s.year})`])) || {},
    orgName: state.navigation.org.name
  };
};

const mapDispatchToProps = () => {
  return {

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OverlayCombinedReport);

